import { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Typography, Box
} from "@mui/material";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import EditIcon from '@mui/icons-material/Edit';
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";
import { CategoriaPagar } from "./TabCategoriasPagar";

type Props = {
    open: boolean;
    onClose: () => void;
    onSaved: () => void;
    categoria: CategoriaPagar | null;
};

export default function ModalCategoriaPagar({ open, onClose, onSaved, categoria }: Props) {
    const [openLoad, setOpenLoad] = useState(false);
    const [nomeCategoria, setNomeCategoria] = useState('');

    const isEdicao = categoria !== null;

    useEffect(() => {
        if (open) {
            setNomeCategoria(categoria ? categoria.nome_categoria : '');
        }
    }, [open, categoria]);

    async function handleSave() {
        if (!nomeCategoria.trim())
            return AlertInfo({ icon: 'info', title: 'Informe o nome da categoria' });

        setOpenLoad(true);
        try {
            const body = { nome_categoria: nomeCategoria.trim() };
            const res = isEdicao
                ? await api.post(`/updatecategoriapagar/${categoria!.id_categoria_pagar}`, body)
                : await api.post('/createcategoriapagar', body);

            if (res.data.success) {
                AlertInfo({ icon: 'success', title: res.data.msg || (isEdicao ? 'Categoria atualizada!' : 'Categoria cadastrada com sucesso!') });
                onSaved();
                onClose();
            } else {
                AlertInfo({ icon: 'error', title: res.data.msg || 'Falha na operação' });
            }
        } catch {
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setOpenLoad(false);
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <SimpleBackdrop open={openLoad} />

            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {isEdicao ? <EditIcon color="primary" /> : <LocalOfferIcon color="primary" />}
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            {isEdicao ? 'Editar Categoria' : 'Nova Categoria'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {isEdicao ? 'Altere o nome da categoria' : 'Cadastre uma categoria de despesa'}
                        </Typography>
                    </Box>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <TextField
                    label="Nome da Categoria *"
                    fullWidth
                    size="small"
                    value={nomeCategoria}
                    onChange={e => setNomeCategoria(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') handleSave(); }}
                    inputProps={{ maxLength: 150, style: { textTransform: 'uppercase' } }}
                    autoFocus
                    sx={{ mt: 0.5 }}
                />
                <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
                    O nome será salvo em letras maiúsculas
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} color="inherit" variant="outlined">
                    Cancelar
                </Button>
                <Button onClick={handleSave} variant="contained" disableElevation>
                    {isEdicao ? 'Salvar Alterações' : 'Criar Categoria'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
